import { HELP_CENTER_URL, BOLT_BLOG_URL, BOLT_GALLERY_URL, BOLT_STATUS_URL } from '~/lib/urls';

export type ResourceLink = {
  href: string;
  name: string;
  shortName: string;
  icon: string;
  openInNewTab?: boolean;
};

export const resourcesLinks: ResourceLink[] = [
  {
    href: HELP_CENTER_URL,
    name: 'Docs & Help Center',
    shortName: 'Support',
    icon: 'i-heroicons:book-open-solid text-lg',
    openInNewTab: true,
  },
  {
    href: BOLT_BLOG_URL,
    name: 'Blog',
    shortName: 'Blog',
    icon: 'i-heroicons:newspaper-solid text-lg',
    openInNewTab: true,
  },
  {
    href: BOLT_GALLERY_URL,
    name: 'Bolt Gallery',
    shortName: 'Gallery',
    icon: 'i-bolt:gallery-stack text-lg',
    openInNewTab: true,
  },
  {
    href: BOLT_STATUS_URL,
    name: 'Status',
    shortName: 'Status',
    icon: 'i-ph:pulse-bold text-lg',
    openInNewTab: true,
  },
];
